import Cookie from './Cookie';
const els = document.querySelectorAll('[data-cookie]');

if (window.Cookiebot) {
    for (let el of els) {
        new Cookie(el);
    }
}
